module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av653-8a31c9023a9a74401fc913ac088b55e8.jpg";